import React, { useEffect, useState } from 'react';
import { connect } from 'dva';
import axios from 'axios';
import PropTypes from 'prop-types';
// import Switch from 'react-switch';
import { COLORS, NOTEABLE_TYPES } from '../../../lib/constants';
import { getFormattedShareType } from '../../../lib/features';
import { getSharesStatus } from '../../../services/udapi/sharing';
import ActiveShares from './ActiveShares';
import Alert from '../../Modals/Alert';
import AlertCircle from '../../../assets/svg/Feather/AlertCircle';
import Button from '../../Button';
import Check from '../../../assets/svg/Feather/Check';
import ghAnalytics from '../../../lib/analytics';
import ShareModal from '../../Modals/ShareModal';
import styles from './SharePanel.module.scss';

/*
  TODO: Uncomment and delete duplicate functions when implementing share permissions
  Check design and flow when moving forward.
  Look for comments with the tag Design v1
  - JT 8/2/22
*/
/* Add INCOMPLETE_SHARE_ID,REACT_APP_INCOMPLETE_SHARE_ID to maps.localenv file */
// const INCOMPLETE_SHARE_ID = process.env.REACT_APP_INCOMPLETE_SHARE_ID
export const SharePanel = (props) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  /* Design v1
  const [isShareable, setIsShareable] = useState(false);
  const [shareLink, setShareLink] = useState('');
  */
  const [shares, setShares] = useState(null);
  const { grantableType, grantableId, isOwner } = props;
  const formattedType = getFormattedShareType(grantableType);

  useEffect(() => {
    getSharesStatus()
      .then((res) => {
        if (res.success) {
          const shares = res.data.filter((share) =>
            share.uuid === grantableId && share.type === grantableType && share.status === 'accepted'
          );
          setShares(shares);
          /* Design v1
          const incompleteShare = res.data.findOne(rd => rd.grenteeRef === INCOMPLETE_SHARE_ID)
          if (incompleteShare) {
            setIsShareable(true)
          }
          */
        }
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [grantableId]);

  /* Design v1
  const generateShareLink = () => {
    if (!shareLink) {
      props.dispatch({
        type: 'toast/show',
        payload: {
          text: 'There was an issue generating a share link',
          icon: AlertCircle,
          iconColor: COLORS.errorRed,
          dismissable: true
        }
      });
    } else {
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(shareLink)
          .then(() => {
            props.dispatch({
              type: 'toast/show',
              payload: {
                text: 'Share link copied to clipboard',
                icon: Check,
                iconColor: COLORS.ghOrange,
                dismissable: true
              }
            });

            ghAnalytics.logShareCopied(grantableId, grantableType, shareLink);
          })
          .catch((err) => {
            props.dispatch({
              type: 'toast/show',
              payload: {
                text: 'There was an issue copying the share link',
                icon: AlertCircle,
                iconColor: COLORS.errorRed,
                dismissable: true
              }
            });
          });
      } else {
        return props.dispatch({
          type: 'modals/add',
          payload: {
            component: ShareModal,
            dismissable: false,
            props: {
              title: 'New Private Link',
              subtitle: 'Copy and paste link to share',
              shareLink: shareLink,
              actionItems: [
                {
                  title: 'Done',
                  theme: Button.THEME.white,
                  onClick: () => {
                    props.dispatch({
                      type: 'modals/close'
                    });
                  }
                }
              ]
            }
          }
        });
      }
    }
  }
  */

  const generateShareLink = () => {
    props.dispatch({
      type: 'share/createShare',
      payload: {
        grantableType: grantableType,
        grantableId: grantableId
      },
      callback: (shareLink) => {
        if (!shareLink) {
          props.dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue generating a share link',
              icon: AlertCircle,
              iconColor: COLORS.errorRed,
              dismissable: true
            }
          });
        } else {
          if (navigator.clipboard) {
            navigator.clipboard
              .writeText(shareLink)
              .then(() => {
                props.dispatch({
                  type: 'toast/show',
                  payload: {
                    text: 'Share link copied to clipboard',
                    icon: Check,
                    iconColor: COLORS.ghOrange,
                    dismissable: true
                  }
                });

                ghAnalytics.logShareCopied(grantableId, grantableType, shareLink);
              })
              .catch((err) => {
                props.dispatch({
                  type: 'toast/show',
                  payload: {
                    text: 'There was an issue copying the share link',
                    icon: AlertCircle,
                    iconColor: COLORS.errorRed,
                    dismissable: true
                  }
                });
              });
          } else {
            return props.dispatch({
              type: 'modals/add',
              payload: {
                component: ShareModal,
                dismissable: false,
                props: {
                  title: 'New Private Link',
                  subtitle: 'Copy and paste link to share',
                  shareLink: shareLink,
                  actionItems: [
                    {
                      title: 'Done',
                      theme: Button.THEME.white,
                      onClick: () => {
                        props.dispatch({
                          type: 'modals/close'
                        });
                      }
                    }
                  ]
                }
              }
            });
          }
        }
      }
    });
  };

  const openRescindShareModal = (url) => (e) => {
    props.dispatch({
      type: 'modals/add',
      payload: {
        component: Alert,
        props: {
          title: `Remove From ${formattedType}.`,
          subtitle: `Are you sure you want to stop sharing your ${formattedType} with this user?`,
          actionItems: [
            {
              title: 'Remove User',
              theme: Button.THEME.orange,
              onClick: () => {
                rescindShare(url);
                props.dispatch({
                  type: 'modals/close'
                });
              }
            },
            {
              title: 'Cancel',
              theme: Button.THEME.white,
              onClick: () => {
                props.dispatch({
                  type: 'modals/close'
                });
              }
            }
          ]
        }
      }
    });
  };

  const rescindShare = (url) => {
    setIsLoading(true);

    axios({
      method: 'patch',
      url,
      withCredentials: true,
      data: {}
    })
      .then((res) => {
        if (res.data.success) {
          props.dispatch({
            type: 'toast/show',
            payload: {
              text: 'Rescinded share.',
              icon: Check,
              iconColor: COLORS.ghOrange
            }
          });

          setTimeout(() => {
            props.dispatch({
              type: 'toast/dismiss'
            });
          }, 3500);

          return getSharesStatus();
        } else {
          props.dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue rescinding the share',
              icon: AlertCircle,
              iconColor: COLORS.errorRed,
              dismissable: true
            }
          });
        }
      })
      .then((res) => {
        if (res.success) {
          const shares = res.data.filter((share) =>
            share.uuid === grantableId && share.type === grantableType && share.status === 'accepted'
          );

          setShares(shares);
        }
      })
      .catch((err) => {
        setError(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  /* Design v1
  const toggleShareState = () => {
    setIsShareable(!isShareable)
    if (!isShareable) {
      props.dispatch({
        type: 'share/createShare',
        payload: {
          grantableId: grantableId,
          grantableType: grantableType,
        }, callback: (shareLink) => {
          if (shareLink) {
            setShareLink(shareLink)
          }
        }
      });
    } else {
      props.dispatch({
        type: 'share/destroyShare',
        payload: {
          grantableId: grantableId,
          grantableType: grantableType,
        }, callback: (shareLink) => {
          if (shareLink) {
            setShareLink(shareLink)
          }
        }
      });
    }
  }
  */

  return (
    <>
      {isOwner ? (
        <>
          <div className={styles.header}>
            <p>Share</p>
          </div>
          <div className={styles.body}>
          <p>Anyone with a link can view this content.</p>
            {/* Design v1
            <Switch
              className='ghSwitch'
              uncheckedIcon={false}
              checkedIcon={false}
              offColor='#333333'
              onColor='#f37735'
              onHandleColor='#ffffff'
              offHandleColor='#ffffff'
              checked={isShareable}
              onChange={toggleShareState}
              width={40}
              height={24}
            />
            */}
          </div>
          <div className={styles.shareEnabled}>
            {/* Design v1
            {isShareable ? (
            */}
              <Button size={Button.SIZE.medium} theme={Button.THEME.orange} style={{ marginTop: '16px' }} onClick={generateShareLink}>
                Copy Link
              </Button>
            {/* Design v1
            ) : null}
            */}
          </div>
          {shares != null ? (
            <ActiveShares shares={shares} rescindShare={rescindShare} openRescindShareModal={openRescindShareModal} />
          ) : null
          }
        </>
      ) : null}
    </>
  );
};

SharePanel.propTypes = {
  isOwner: PropTypes.bool,
  grantableId: PropTypes.string,
  grantableType: PropTypes.oneOf(Object.values(NOTEABLE_TYPES))
};

export default connect((model) => ({}))(SharePanel);
